export { renderRadioGroup_unstable as renderRadioGroup } from '@fluentui/react-radio';
